<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 支払一覧詳細画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="支払基本情報" name="payBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 仕入先 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.CUSTOMER_PAY.SUPPLIER_COMPANY')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="cusPayEditForm.pbSupCode"
                      placeholder=""
                      class="commonDialog"
                      :disabled="btnRcvSelectFlg"
                      @change="supCodeChange"
                    >
                      <t-option
                        v-for="item in supCodeList"
                        :key="item.supCode"
                        :label="item.supCode + ':' + item.supAbbreviation"
                        :value="item.supCode"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="colArr.colCom">
                  <!-- 連絡担当 -->
                  <t-form-item
                    :label="$t('resource.TRANSPORT.CONNECTER')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="cusPayEditForm.pbUserCode"
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- 支払予定日 -->
                <t-col :span="colArr.colCom">
                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- 課題_支払日と請求日の変更 -->
                  <!-- <t-form-item
                    :label="$t('resource.CUSTOMER_PAY.PAY_EXPECTED_DATE')"
                    class="marginBottom"
                  > -->
                  <t-form-item
                    :label="$t('resource.CUSTOMER_PAY.PAY_CRE_DATE')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                    <t-date-picker
                      v-model="cusPayEditForm.pbPayExpectedDate"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :clearable="false"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_支払日と請求日の変更 -->
                <!-- 支払日 -->
                <!-- <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.CUSTOMER_PAY.PAY_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="cusPayEditForm.pbPayDate"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :clearable="false"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col> -->

                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.STATUS')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="cusPayEditForm.pbStatus"
                      placeholder=""
                      class="commonDialog"
                      style="width: 100%"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_支払日と請求日の変更 -->
              <!-- <t-row type="flex" justify="center">
                <t-col :span="colArr.colL">&nbsp;</t-col> -->
              <!-- 状態 -->
              <!-- <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.STATUS')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="cusPayEditForm.pbStatus"
                      placeholder=""
                      class="commonDialog"
                      style="width: 100%"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colCom * 3">&nbsp;</t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row> -->
              <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 備考 -->
                <t-col :span="colArr.colCom * 4">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.REMARKS')"
                    class="marginBottom"
                  >
                    <t-input
                      type="textarea"
                      maxlength="500"
                      v-model="cusPayEditForm.pbRemarks"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>
          <t-row>
            <t-col :span="5" class="left">
              <!-- 日本入荷データ選択 -->
              <t-button
                round
                type="primary"
                class="button_long_search"
                @click="CusPayRcvSelectDialog"
                ref="selectBtn"
                :disabled="btnRcvSelectFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.CUSTOMER_PAY.OFFICE_RECEIVE_SELECT") }}
              </t-button></t-col
            >

            <!-- クローズデータ選択 -->
            <t-col :span="5" class="left">
              <t-button
                round
                type="primary"
                class="button_long_search"
                @click="cusPayCloseSelectDialog"
                ref="closeSelectBtn"
                :disabled="btnRcvSelectFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.CUSTOMER_PAY.CLOSE_DATA_SELECT") }}
              </t-button>
            </t-col>

            <t-col :span="14">&nbsp;</t-col>
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            >
              <!-- 支払書出力 -->
              <!-- <t-button
                round
                type="primary"
                class="button_long_search"
                @click="OutPutClick"
                ref="outputBtn"
                :disabled="btnOutputFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.CUSTOMER_PAY.PAY_LIST_OUTPUT") }}
              </t-button> -->
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="cusPayTableData"
                :data="cusPayTableData"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :cell-class-name="TableCellClassName"
                :row-class-name="rowClassName"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columnNameSet()"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="
                    column.prop === 'aodProdRemarksSum'
                      ? true
                      : column.overflowTooltip
                  "
                >
                  <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- 課題_備考機能の追加 -->

                  <template #default="scope">
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                    <!-- 共通備考の調整 -->
                    <template v-if="column.prop === 'aodProdRemarksSum'">
                      <!-- <div class="button-container">
                        <t-tooltip placement="bottom" effect="light">
                          <div
                            slot="content"
                            class="tooltip-content"
                            v-html="
                              formatRemarksShowProc(scope.row.aodProdRemarksSum)
                            "
                          ></div>
                          <t-button
                            :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                            icon="el-icon-search"
                            size="small"
                            circle
                          >
                          </t-button>
                        </t-tooltip>
                      </div> -->
                      <div class="bikouDiv">
                        <!-- 備考表示 -->
                        <span class="bikouText">
                          {{ scope.row.aodProdRemarksSum }}
                        </span>
                      </div>
                    </template>
                    <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>

                  <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form
          label-position="right"
          :label-width="
            $t('widgetSize.CUSTOMER_PAY_EDIT_DIALOG.AMOUNT_LABEL_WIDTH')
          "
        >
          <t-row class="marginBottom">
            <t-col :span="19">&nbsp;</t-col>
            <!--  合計(CNY) -->
            <t-col :span="5">
              <t-input
                v-model="pdSumCny"
                disabled
                class="sumInput"
                style="margin-right: 5px; margin-top: 10px"
              >
                <template slot="prepend">{{
                  $t("resource.CUSTOMER_PAY.SUM_CNY")
                }}</template>
              </t-input>
            </t-col>
          </t-row>
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="24">
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  :disabled="payConfirmFlg"
                  @click="payConfirm"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowCusPayCloseSelectDialog,
  ShowCustomerPayRcvSelectDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  addCusPayDetail,
  initCustPaySearchList,
  searchCloseToPayInfo,
  searchCusPayDetail,
  searchJpReceToPayInfo,
  updateCusPayDetail,
} from "@/services/customerPayInfo";
import {
  cmpBasicData,
  cmpDetailData,
  formatCurDateToString,
  formatCurrencyToNumber,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  formatUndefinedToDate,
  getAbleSupplierInfoList,
  getAbleUserInfoList,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NUM_ONE,
  NUM_ZERO,
  STR_COLON,
  STR_EMPTY,
  STR_HYPHEN,
  STR_ZERO,
} from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["payBasic"],
      // 支払状態
      statusList: [],
      //連絡担当
      connecterList: [],
      //仕入先リスト
      supCodeList: [],
      //プロセス区分リスト
      procKbnList: [],
      //「支払書出力」ボタン可用のフラグ
      btnOutputFlg: true,
      //「日本入荷データ選択」ボタン可用のフラグ
      btnRcvSelectFlg: false,
      // 「赤出荷伝票選択」ボタン可用のフラグ
      btnRedSelectFlg: true,
      payConfirmFlg: true,

      closeKbn: 0, //クローズデータ区分(0:通常データ,1:クローズデータ)
      cusPayEditForm: {
        pbPayNo: "", //支払No.
        pbSupCode: "", // 仕入先
        pbUserCode: "", // 連絡担当
        pbPayExpectedDate: "", // 支払予定日
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_支払日と請求日の変更
        // pbPayDate: "", // 支払日
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        pbStatus: "", // 状態
        pbRemarks: "", // 備考
        //表示しない
        pbCurType: "", //貨幣タイプ
        pbExr: "", // レート
        pbUpdateTime: "", //更新時刻
        pbUpdateUser: "", //更新者
      },
      pdSumCny: "", // 合計(CNY)

      // テーブルの運送製品データ
      cusPayDetailData: [],
      selectSearchForm: [], //支払入荷選択画面の検索条件
      selectCloseSearchForm: [], //クローズデータ選択画面の検索条件
      cusPayTableData: [],
      //支払見積依頼のテーブルの列
      columns: [
        {
          // 日本入荷日 -> 入荷日
          prop: "jrbReceDate",
          label: t("resource.CUSTOMER_PAY.OFFICER_RECEIVE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 注文No
        {
          prop: "jrdOrderNoShow",
          label: t("resource.CUSTOMER_PAY.ORDER_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.orderInfo.productName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.orderInfo.pictureNo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 入荷OK数
        {
          prop: "pdPayQty",
          label: t("resource.CUSTOMER_PAY.CHECK_RECEIVE_QUANTITY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // 加工単価(CNY)
        {
          prop: "pdUPrice",
          label: t("resource.CUSTOMER_PAY.PROCESS_UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 小計(CNY)
        {
          prop: "pdUTotal",
          label: t("resource.CUSTOMER_PAY.SUBTOTAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
      ],

      supplementColumns: [
        // 注文No
        {
          prop: "jrdOrderNoShow",
          label: t("resource.CUSTOMER_PAY.ORDER_NO"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.width170"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          // overflowTooltip: true,
          // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.orderInfo.productName"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.width150"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // overflowTooltip: true,
          overflowTooltip: true,
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.orderInfo.pictureNo"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.width150"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // overflowTooltip: true,
          overflowTooltip: true,
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        },
        //補足数
        {
          prop: "pdPayQty",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓

        //補足金額
        // {
        //   prop: "pdSupplementAmount",
        //   label: t("resource.CUSTOMER_PAY.SUPPLEMENT_AMOUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        // },

        //補足単価
        {
          prop: "pdPayUPrice",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_U_PRICE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },

        //補足金額小計
        {
          prop: "pdPayTotPrice",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 製品区分
        // {
        //   prop: "odProdExKbnShow",
        //   label: t("resource.CUSTOMER_PAY.PROD_EX_KBN"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        // },

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // // 備考
        // {
        //   prop: "odRemarks",
        //   label: t("resource.CUSTOMER_PAY.REMARKS"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // 備考
        {
          label: t("resource.REMARKS_ADD.REMARKS"),
          class: "cell_txt_center",
          prop: "aodProdRemarksSum",
          //min_width: 100,
          width: 100,
          scopedSlots: {
            default: "aodProdRemarksSum",
          },
        },
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      ],
      oldSupCode: "",

      //受注一覧選択情報
      orderProductForm: [{}],

      //追加された「仕入先」列の番号
      newColumnNo: 0,

      localIsAdd: this.isAdd,

      showFlag: false,

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      // // 基本情報のheight
      // //49: collapseのheight 45: 輸送方式のheight　45：目的地　65：備考　45：ボタン
      // basicHeight: 49 + 45 + 45 + 65 + 45,
      // //明細情報のheight  (window.innerHeight * (1 - 0.1) - 65): 画面のheight
      // detailHeight:
      //   window.innerHeight * (1 - 0.1) -
      //   65 -
      //   (49 + 45 + 45 + 65 + 45) -
      //   DIALOG_LINE_HEIGHT * 2 -
      //   25,
      // 基本情報のheight
      //49: collapseのheight 45: 輸送方式のheight　45：目的地　65：備考　45：ボタン
      basicHeight: 49 + 45 + 65 + 45,
      //明細情報のheight  (window.innerHeight * (1 - 0.1) - 65): 画面のheight
      detailHeight:
        window.innerHeight * (1 - 0.01) -
        65 -
        (49 + 45 + 65 + 45) -
        DIALOG_LINE_HEIGHT * 2 -
        25,
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 2,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },
  mounted() {
    this.init(this.rowData);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  // watch: {
  //   "cusPayEditForm.pbStatus"(newVal, oldVal) {
  //     //状態が「支払済み」に変更する時、日本入荷データ選択ボタンが使用可能になる
  //     if (newVal === "2" || newVal === this.statusList[1].label) {
  //       this.btnRcvSelectFlg = true;
  //     } else {
  //       this.btnRcvSelectFlg = false;
  //     }
  //   },
  // },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("payBasic") !== -1) {
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_支払日と請求日の変更
        // this.basicHeight = 49 + 45 + 45 + 65 + 45;

        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45 + 45 + 65 + 45) -
        //   DIALOG_LINE_HEIGHT * 2 -
        //   25;

        this.basicHeight = 49 + 45 + 65 + 45;

        this.detailHeight =
          window.innerHeight * (1 - 0.01) -
          65 -
          (49 + 45 + 65 + 45) -
          DIALOG_LINE_HEIGHT * 2 -
          25;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      } else {
        this.basicHeight = 49 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45) -
        //   DIALOG_LINE_HEIGHT * 2 -
        //   20;
        this.detailHeight =
          window.innerHeight * (1 - 0.01) -
          65 -
          (49 + 45) -
          DIALOG_LINE_HEIGHT * 2 -
          20;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },
    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      //検索条件リストの初期化(状態、支払状態)
      initCustPaySearchList()
        .then((res) => {
          //支払状態のクリア
          this.statusList = res.payStatusList;
          // 連絡担当
          this.connecterList = res.userInfoList;
          //仕入先リスト
          this.supCodeList = res.supInfoList;
          //プロセス区分リスト
          this.procKbnList = res.procKbnList;
          //支払情報の初期化
          this.InfoInit(data);
          //setColumnWidth(this.columns, this.cusPayTableData);
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE"));
        });
      //setColumnWidth(this.columns, this.cusPayTableData);

      // setColumnWidth(this.columnNameSet(), this.cusPayTableData);
    },

    //支払情報の初期化
    InfoInit(data) {
      if (this.localIsAdd) {
        this.activeNames = ["payBasic"];
        this.handleCollapseChange(this.activeNames);

        //支払予定日:システム日
        this.cusPayEditForm.pbPayExpectedDate = new Date();
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_支払日と請求日の変更
        //支払日
        // this.cusPayEditForm.pbPayDate = new Date();
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        //連絡担当
        this.cusPayEditForm.pbUserCode = getUserInfo().UserId;
        // 状態
        this.cusPayEditForm.pbStatus = "1";
        this.getAbleList();

        // this.cusPayEditForm.pbSupCode = this.supCodeList[0]?.supCode;

        //「支払書出力」ボタンを使用可能にする
        this.btnOutputFlg = true;
        this.showFlag = false;
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);
        this.cusPayEditForm = data;
        // 「支払書出力」ボタンは使用できません
        this.btnOutputFlg = false;
        //注文NOによる注文詳細情報の取得
        this.searchCusPayDetailProc();
        this.payConfirmFlg = false;
      }
    },

    // 使用可能な担当者リスト、得意先リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.cusPayEditForm.pbUserCode
      );

      var supCode;
      if (!!this.cusPayEditForm.pbSupCode) {
        supCode = this.cusPayEditForm.pbSupCode.split(":")[0];
      }
      // 得意先リスト
      this.supCodeList = getAbleSupplierInfoList(this.supCodeList, supCode);

      if (!this.cusPayEditForm.pbSupCode) {
        this.cusPayEditForm.pbSupCode = this.supCodeList[0]?.supCode;
      }
    },

    //支払NOによる支払詳細情報の取得
    searchCusPayDetailProc() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      searchCusPayDetail({ customerPayBasicInfo: this.cusPayEditForm })
        .then((res) => {
          this.cusPayEditForm = res.customerPayBasicInfo;

          this.cusPayEditForm.pbStatus = res.customerPayBasicInfo.pbStatusCode;

          if (
            this.cusPayEditForm.pbStatus === "2" ||
            this.cusPayEditForm.pbStatus === this.statusList[1].label
          ) {
            this.btnRcvSelectFlg = true;
          } else {
            this.btnRcvSelectFlg = false;
          }

          this.cusPayTableData = res.customerPayDetailInfoList;
          this.oldSupCode = this.cusPayEditForm.pbSupCode;

          this.closeKbn = res.customerPayBasicInfo.closeKbn;

          this.getAbleList();
          //データの変換処理
          this.editDataProcess();
          // setColumnWidth(this.columns, this.cusPayTableData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    editDataProcess() {
      //支払予定日が空のチェック
      this.cusPayEditForm.pbPayExpectedDate = formatUndefinedToDate(
        this.cusPayEditForm.pbPayExpectedDate
      );
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      //支払日が空のチェック
      // this.cusPayEditForm.pbPayDate = formatUndefinedToDate(
      //   this.cusPayEditForm.pbPayDate
      // );
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      this.dataProcess();
    },

    //データの変換処理
    dataProcess() {
      let detailResult = [];

      this.cusPayTableData.map((item, index) => {
        if (this.closeKbn === NUM_ONE) {
          item.jrbReceDate = STR_HYPHEN;
        } else {
          //日本入荷日が空のチェック
          item.jrbReceDate = formatCurDateToString(item.jrbReceDate);
        }
        if (!!!item.pdPayQty) {
          item.pdPayQty = NUM_ZERO;
        }
        if (!!!item.pdUPrice) {
          item.pdUPrice = NUM_ZERO;
        }

        if (this.closeKbn == NUM_ONE) {
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          //補足金額
          // item.pdSupplementAmount = formatStringToCurrency(
          //   item.pdSupplementAmount
          // );

          // 補足金額小計
          item.pdPayTotPrice = formatStringToCurrency(
            item.pdPayUPrice * item.pdPayQty
          );
          // 補足単価
          item.pdPayUPrice = formatStringToCurrency(item.pdPayUPrice);
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        } else {
          //小計
          item.pdUTotal = formatStringToCurrency(item.pdUPrice * item.pdPayQty);
          //加工単価
          item.pdUPrice = formatStringToCurrency(item.pdUPrice);
        }

        item.index = index;

        detailResult.push(item);

        return item;
      });

      // 読み込み回数 = 1
      if (!this.localIsAdd && this.numLoads == 1) {
        // 比較用基本情報
        this.cmpBasicResult = JSON.parse(
          JSON.stringify(this.extractBasic(this.cusPayEditForm))
        );

        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(detailResult));

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }

      this.updTotalData();
    },

    //「確定」ボタン
    payConfirm() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      if (this.cusPayTableData && this.cusPayTableData.length >= 1) {
        if (this.localIsAdd) {
          this.addCusPayDetailProc();
        } else {
          this.updateCusPayDetailProc();
        }
      } else {
        this.showFlag = false;
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    // 詳細情報の更新
    updateCusPayDetailProc() {
      if (this.closeKbn === NUM_ONE) {
        this.closeDataAddUpdProc();
      } else {
        this.dataAddUpdProc();
      }

      updateCusPayDetail({
        customerPayBasicInfo: this.cusPayEditForm,
        customerPayDetailInfoList: this.cusPayDetailData,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.searchCusPayDetailProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
      // .finally(() => {
      //   this.searchCusPayDetailProc();
      // });
    },

    //明細情報の追加
    addCusPayDetailProc() {
      if (this.closeKbn === NUM_ONE) {
        this.closeDataAddUpdProc();
      } else {
        this.dataAddUpdProc();
      }

      // ADD 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 start↓
      // 新規製品保存後、支払状態が「支払済み」を変更する
      this.cusPayEditForm.pbStatus = this.statusList.find(
        (item) => item.label === "支払済み"
      )?.value;
      // ADD 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 end↑

      addCusPayDetail({
        customerPayBasicInfo: this.cusPayEditForm,
        customerPayDetailInfoList: this.cusPayDetailData,
      })
        .then((res) => {
          this.cusPayEditForm.pbPayNo = res;
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.localIsAdd = false;
          this.searchCusPayDetailProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        });
      // .finally(() => {
      //   this.searchCusPayDetailProc();
      // });
    },

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      //仕入先
      this.cusPayEditForm.pbSupCode =
        this.cusPayEditForm.pbSupCode.split(STR_COLON)[0];

      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 start↓
      // 不要コード削除（判断条件に問題があり、トリガされない）
      // // 連絡担当
      // this.connecterList.map((item) => {
      //   if (
      //     !!this.cusPayEditForm.pbUserCode &&
      //     item.label === this.cusPayEditForm.pbUserCode
      //   )
      //     this.cusPayEditForm.pbUserCode = this.connecterList.find(
      //       (it) => it.label === this.cusPayEditForm.pbUserCode
      //     )?.value;
      // });
      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 end↑

      this.cusPayEditForm.pbCurType = this.supCodeList.find(
        (it) => it.supCode === this.cusPayEditForm.pbSupCode
      )?.supCurrency;

      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 start↓
      // 不要コード削除（判断条件に問題があり、トリガされない）
      // // 状態
      // if (this.cusPayEditForm.pbStatus) {
      //   this.statusList.map((item) => {
      //     if (item.label == this.cusPayEditForm.pbStatus) {
      //       this.cusPayEditForm.pbStatus = this.statusList.find(
      //         (it) => it.label === this.cusPayEditForm.pbStatus
      //       )?.value;
      //     }
      //   });
      // }
      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 end↑

      // 支払予定日
      this.cusPayEditForm.pbPayExpectedDate = formatCurDateToString(
        this.cusPayEditForm.pbPayExpectedDate
      );
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      // 支払日
      // this.cusPayEditForm.pbPayDate = formatCurDateToString(
      //   this.cusPayEditForm.pbPayDate
      // );
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      // レート
      this.cusPayEditForm.pbExr = this.cusPayTableData[0].pbExr;
      // if (
      //   !!!this.cusPayEditForm.pbExr ||
      //   this.cusPayEditForm.pbExr == STR_EMPTY
      // ) {
      //   this.cusPayEditForm.pbExr = this.procKbnList[0].value;
      // }
      //更新者
      this.cusPayEditForm.pbUpdateUser = getUserInfo().UserId;

      this.cusPayDetailData = [];
      for (let index = 0; index < this.cusPayTableData.length; index++) {
        const element = this.cusPayTableData[index];
        this.cusPayDetailData.push({
          pdPayNo: this.cusPayEditForm.pbPayNo, // 支払No.
          pdPayDetailNo: index + 1, // 支払明細No.
          pdPayQty: element.pdPayQty, // 支払数量
          pdUPrice: formatCurrencyToNumber(element.pdUPrice), // 加工単価
          pdUTotal: formatCurrencyToNumber(element.pdUTotal), // 小計

          pdReceNo: element.pdReceNo, //入荷No
          pdReceDetailNo: element.pdReceDetailNo, //入荷明細No
          pdQuoteNo: element.pdQuoteNo, //受注基本情報_見積No.
          pdProdNo: element.pdProdNo, // 受注明細_受注明細No.
          pdUpdateUser: getUserInfo().UserId, //更新者

          jrdOrderNo: element.jrdOrderNo, // 注文No
          jrdDetailNo: element.jrdDetailNo, // 注文明細No
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 現象：ミスミデータ作成に失敗しました。ミスミ大連のデータは取得の場合、検査室入荷データと日本入荷データは区別されていない
          aodMisumiKbn: element.aodMisumiKbn,
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

        });

      }
    },

    // 更新/追加されたデータ処理
    closeDataAddUpdProc() {
      //仕入先
      this.cusPayEditForm.pbSupCode =
        this.cusPayEditForm.pbSupCode.split(STR_COLON)[0];

      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 start↓
      // 不要コード削除（判断条件に問題があり、トリガされない）
      // // 連絡担当
      // this.connecterList.map((item) => {
      //   if (
      //     !!this.cusPayEditForm.pbUserCode &&
      //     item.label === this.cusPayEditForm.pbUserCode
      //   )
      //     this.cusPayEditForm.pbUserCode = this.connecterList.find(
      //       (it) => it.label === this.cusPayEditForm.pbUserCode
      //     )?.value;
      // });
      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 end↑

      this.cusPayEditForm.pbCurType = this.supCodeList.find(
        (it) => it.supCode === this.cusPayEditForm.pbSupCode
      )?.supCurrency;

      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 start↓
      // 不要コード削除（判断条件に問題があり、トリガされない）
      // // 状態
      // if (this.cusPayEditForm.pbStatus) {
      //   this.statusList.map((item) => {
      //     if (item.label == this.cusPayEditForm.pbStatus) {
      //       this.cusPayEditForm.pbStatus = this.statusList.find(
      //         (it) => it.label === this.cusPayEditForm.pbStatus
      //       )?.value;
      //     }
      //   });
      // }
      // DEL 2025/11/20 Wjx 課題_251119顧客からの改善したい点への対応 end↑

      // 支払予定日
      this.cusPayEditForm.pbPayExpectedDate = formatCurDateToString(
        this.cusPayEditForm.pbPayExpectedDate
      );
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_支払日と請求日の変更
      // 支払日
      // this.cusPayEditForm.pbPayDate = formatCurDateToString(
      //   this.cusPayEditForm.pbPayDate
      // );
      // // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // レート
      if (
        !!!this.cusPayEditForm.pbExr ||
        this.cusPayEditForm.pbExr == STR_EMPTY
      ) {
        this.cusPayEditForm.pbExr = this.procKbnList[0].value;
      }
      //更新者
      this.cusPayEditForm.pbUpdateUser = getUserInfo().UserId;

      this.cusPayDetailData = [];
      for (let index = 0; index < this.cusPayTableData.length; index++) {
        const element = this.cusPayTableData[index];
        this.cusPayDetailData.push({
          pdPayNo: this.cusPayEditForm.pbPayNo, // 支払No.
          pdPayDetailNo: index + 1, // 支払明細No.
          pdPayQty: element.pdPayQty, // 支払数量

          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // pdUPrice: formatCurrencyToNumber(element.pdUPrice), // 加工単価
          // pdUTotal: formatCurrencyToNumber(element.pdUTotal), // 小計
          // pdSupplementAmount: formatCurrencyToNumber(
          //   element.pdSupplementAmount
          // ), // 小計
          pdUPrice: formatCurrencyToNumber(element.pdPayUPrice), // 加工単価
          pdUTotal: formatCurrencyToNumber(element.pdPayTotPrice), // 小計
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          pdOrderNo: element.jrdOrderNo, //注文No.
          pdDetailNo: element.jrdDetailNo, // 注文明細No.

          pdQuoteNo: element.pdQuoteNo, //受注基本情報_見積No.
          pdProdNo: element.pdProdNo, // 受注明細_受注明細No.
          pdUpdateUser: getUserInfo().UserId, //更新者

          jrdOrderNo: element.jrdOrderNo, // 注文No
          jrdDetailNo: element.jrdDetailNo, // 注文明細No
        });
      }
    },

    supCodeChange() {
      if (this.oldSupCode !== this.cusPayEditForm.pbSupCode) {
        this.cusPayTableData = [];
        this.oldSupCode = this.cusPayEditForm.pbSupCode;
      }
    },

    //セルの配置
    TableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      if (
        (column.property === "pdPayQty" && row.pdPayQty < 0) ||
        (column.property === "pdUTotal" &&
          formatCurrencyToNumber(row.pdUTotal) < 0) ||
        (column.property === "pdPayTotPrice" &&
          formatCurrencyToNumber(row.pdPayTotPrice) < 0)
      ) {
        return "txt-cell-editable_red";
      }
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    // 支払入荷選択画面を表示
    CusPayRcvSelectDialog() {
      ShowCustomerPayRcvSelectDialog(
        {
          tableData: this.cusPayTableData,
          pbSupCode: this.cusPayEditForm.pbSupCode,
          selectSearchForm: this.selectSearchForm,
          pbPayNo: this.cusPayEditForm.pbPayNo,
        },
        t("resource.CUSTOMER_PAY.PAY_RECEIVE_SELECT_DIALOG"),

        (target) => {
          if (!!target) {
            if (this.closeKbn !== NUM_ZERO) {
              this.cusPayTableData = [];
              this.closeKbn = NUM_ZERO;
            }

            // 支払入荷選択画面の検索条件
            this.selectSearchForm = target.find(
              (item) => item.key === "selectSearchForm"
            ).value;

            searchJpReceToPayInfo({
              customerPayDetailInfoList: target.find(
                (item) => item.key === "selectedProcForm"
              ).value,
            })
              .then((res) => {
                this.cusPayTableData = [];
                this.cusPayTableData = res.customerPayDetailInfoList;

                //仕入先コード
                this.cusPayEditForm.pbSupCode =
                  this.cusPayTableData[0].pbSupCode;
                //貨幣タイプ
                this.cusPayEditForm.pbCurType =
                  this.cusPayTableData[0].pbCurType;

                this.dataProcess();
                // setColumnWidth(this.columns, this.cusPayTableData);
                //確定ボタンが使用可能に変更
                this.payConfirmFlg = false;
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });
          }
        }
      );
      if (typeof this.$refs.selectBtn !== "undefined") {
        // フォーカス削除
        this.$refs.selectBtn.$el.blur();
      }
    },

    // クローズデータ選択画面を表示
    cusPayCloseSelectDialog() {
      if (typeof this.$refs.closeSelectBtn !== "undefined") {
        // フォーカス削除
        this.$refs.closeSelectBtn.$el.blur();
      }
      var tableData = [];
      if (this.closeKbn === NUM_ONE) {
        tableData = this.cusPayTableData;
      }

      ShowCusPayCloseSelectDialog(
        {
          tableData: tableData,
          pbSupCode: this.cusPayEditForm.pbSupCode,
          selectCloseSearchForm: this.selectCloseSearchForm,
          pbPayNo: this.cusPayEditForm.pbPayNo,
        },
        t("resource.CUSTOMER_PAY.CLOSE_DATA_SELECT"),
        (target) => {
          if (!!target) {
            if (this.closeKbn !== NUM_ONE) {
              this.cusPayTableData = [];
              this.closeKbn = NUM_ONE;
            }
            // 支払入荷選択画面の検索条件
            this.selectCloseSearchForm = target.find(
              (item) => item.key === "selectCloseSearchForm"
            ).value;

            searchCloseToPayInfo({
              customerPayDetailInfoList: target.find(
                (item) => item.key === "selectedProcForm"
              ).value,
              payNo: this.cusPayEditForm.pbPayNo,
            })
              .then((res) => {
                this.cusPayTableData = [];
                this.cusPayTableData = res.customerPayDetailInfoList;

                //仕入先コード
                this.cusPayEditForm.pbSupCode =
                  this.cusPayTableData[0].pbSupCode;
                //貨幣タイプ
                this.cusPayEditForm.pbCurType =
                  this.cusPayTableData[0].pbCurType;

                this.dataProcess();
                // setColumnWidth(this.columns, this.cusPayTableData);
                //確定ボタンが使用可能に変更
                this.payConfirmFlg = false;
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });
          }
        }
      );
    },

    updTotalData() {
      //合計(CNY)
      var pdSumCny = 0;
      if (this.cusPayTableData.length >= 1) {
        for (let index = 0; index < this.cusPayTableData.length; index++) {
          var element = this.cusPayTableData[index];

          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          //   if (this.closeKbn === NUM_ONE) {
          //     pdSumCny += parseInt(
          //       formatCurrencyToNumber(element.pdSupplementAmount)
          //     );
          //   }
          //   pdSumCny += parseInt(formatCurrencyToNumber(element.pdUTotal));

          if (this.closeKbn === NUM_ONE) {
            //補足データの場合、補足金額小計
            pdSumCny += parseInt(formatCurrencyToNumber(element.pdPayTotPrice));
          } else {
            //小計
            pdSumCny += parseInt(formatCurrencyToNumber(element.pdUTotal));
          }
        }
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      }
      //合計(CNY)を表示
      this.pdSumCny = formatStringToCurrency(pdSumCny);
    },

    extractBasic(data) {
      return {
        pbSupCode: data.pbSupCode,
        pbUserCode: data.pbUserCode,

        pbPayExpectedDate: formatDateToString(data.pbPayExpectedDate),
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_支払日と請求日の変更
        // pbPayDate: formatDateToString(data.pbPayDate),
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        pbStatus: data.pbStatus,
        pbRemarks: data.pbRemarks,
      };
    },

    // 製品異常
    rowClassName({ row }) {
      if (!!row.odProdExKbn && row.odProdExKbn != STR_EMPTY) {
        if (row.odProdExKbn !== STR_ZERO) {
          return "textColor";
        }
      }
    },
    OutPutClick() {
      this.$message("「支払書出力」ボタン");
      // フォーカス削除
      this.$refs.outputBtn.$el.blur();
    },

    //列の設定
    columnNameSet() {
      if (this.closeKbn == NUM_ONE) {
        return this.supplementColumns;
      }
      return this.columns;
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.localIsAdd) {
        isDataChanged = this.cusPayTableData.length > 0;
      } else {
        // const extractedBasic = this.extractBasic(this.cusPayEditForm);
        // const extractedDetails = this.extractDetails(this.cusPayTableData);
        isDataChanged =
          !cmpBasicData(
            this.cmpBasicResult,
            this.extractBasic(this.cusPayEditForm)
          ) || !cmpDetailData(this.cmpDetailResult, this.cusPayTableData);
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      const width = getRemarksColumnWidth(this.cusPayTableData);

      this.$nextTick(() => {
        if (this.$refs.cusPayTableData) {
          this.$refs.cusPayTableData.doLayout();
          const cells = document.querySelectorAll(".el-tooltip");
          cells.forEach((cell) => {
            cell.style.width = `${width}px`;
            cell.style.minWidth = `${width}px`;
          });
        }
      });
      return width;
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
</style>
